import { buildReducer } from '../../../shared';
import type { MoveContactsState } from '../../state/moveContactsState';
import { moveContactsClickedAction } from '../../actions/user/moveContactActions';
import { moveContactsCompletedAction } from '../../actions/data/moveContactsDataActions';

/**
 * Keeps track of personas being moved
 */

export const defaultState: MoveContactsState = {
    personas: [],
    fromFolderId: null,
    toFolderId: null,
    isMoveInProgress: false,
};

export default buildReducer<MoveContactsState>()
    .handle(moveContactsClickedAction, (state, action) => {
        return {
            ...state,
            ...action.payload,
            isMoveInProgress: true,
        };
    })
    .handleDataAction(
        moveContactsCompletedAction,
        (state, action) => {
            return defaultState;
        },
        (state, action) => {
            return defaultState;
        }
    )
    .done(defaultState);
export type { Action } from '../../../shared';
